import { FC } from 'react'
import { Flex } from '@chakra-ui/react'

import { Empty } from 'components'
import CustomFormAnswerItem from './components/CustomFormAnswerItem'
import CustomFormAnswerManagerProvider from './contexts/CustomFormViewerQuestionManager/Provider'
import { CustomFormAnswer } from '../../types'

export type ValidationAnswerRoute = (params: { questionId?: string; data: any }) => Promise<{
  header?: {
    success: boolean
  }
  body?: {
    form_answer?: any
  }
}>

type Props = {
  answers: CustomFormAnswer[]
  validationAnswer?: ValidationAnswerRoute
}

const CustomFormAnswers: FC<Props> = ({ answers, validationAnswer }) => {
  return (
    <Flex flexDir="column" w="100%" gap={2}>
      {answers ? (
        <Flex flexDir="column" gap={2}>
          {answers.map((answer, index) => {
            return (
              <CustomFormAnswerManagerProvider key={answer.id} answer={answer} validationAnswer={validationAnswer}>
                <CustomFormAnswerItem totalAnswers={answers.length} index={index} />
              </CustomFormAnswerManagerProvider>
            )
          })}
        </Flex>
      ) : (
        <Empty title="Formulário encontrado mas não há nenhuma questão" />
      )}
    </Flex>
  )
}

export default CustomFormAnswers
